import styled from '@emotion/styled';
import { css } from 'emotion';

export const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`;

export const DivLineWithButtonMargin = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;

export const NavigateContainer = styled.div`
  display: flex;
  flex-direction: column;
  & .bp3-button {
    margin-bottom: 5px;
  }
`;

export const DivSlimColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 20px;
`;

export const Title = styled.h2({
  marginRight: '120px',
  marginTop: 0,
  marginBottom: 2,
});

export const imageButtonStyle = css({
  padding: 0,
  marginRight: 10,
});

export const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  line-height: 27spx;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
